module.exports = __webpack_public_path__ + "img/back.4f137ca7.png";